import { EVENT_TYPES } from ".";
import { logActivity } from "utils";

const extractLevelNumber = (levelString) => {
  if (!levelString) return 1;
  if (typeof levelString === "number") return levelString;

  const match = levelString.match(/^(\d+)/);
  return match ? parseInt(match[1], 10) : 1;
};

const getBadgeTitle = (levelString) => {
  if (!levelString) return levelString;
  if (typeof levelString === "number") return levelString;

  const parts = levelString.split(" - ");
  if (parts.length > 1) {
    return parts[1].trim();
  }

  return levelString;
};

export const discussionAnalyzed = ({
  dataTrackEvent,
  setDiscussionAnalysis,
  setIsAnalysisLoading,
  setShowDiscussionAnalyzed,
  hasAnalysisDataRef,
  setCollaborationTip,
  sessionContext = {},
}) => {
  if (dataTrackEvent.event_type === EVENT_TYPES.DISCUSSION_ANALYZED) {
    try {
      const analysisString = dataTrackEvent.data?.analysis;
      if (!analysisString) {
        return;
      }

      // Handle both formats: direct JSON or markdown-wrapped JSON
      let jsonString = analysisString;
      const jsonMatch =
        analysisString.match(/```json\n([\s\S]*?)\n```/) ||
        analysisString.match(/```\n([\s\S]*?)\n```/);
      if (jsonMatch) {
        jsonString = jsonMatch[1];
      }

      const analysisData = JSON.parse(jsonString);

      // Support both new format (flat) and old format (nested under studentFacingReport)
      const report = analysisData.studentFacingReport || analysisData;

      const collaborationLevelString = report.collaborationLevel;
      const level = extractLevelNumber(collaborationLevelString);
      // Handle both topQuote (new) and topQuotes array (old)
      const topQuote = report.topQuote || (report.topQuotes && report.topQuotes[0]);
      const studentFacingFeedback = report.studentFacingFeedback;
      const collaborationTip = report.collaborationTip;
      const badgeTitle = getBadgeTitle(collaborationLevelString);
      const badgeType = "Teamwork";

      // Log discussion analysis to Sentry
      logActivity("Discussion analyzed", {
        activityType: "consensus",
        collaborationLevel: level,
        badgeTitle,
        badgeType,
        hasQuote: !!topQuote?.quote,
        hasFeedback: !!studentFacingFeedback,
        hasCollaborationTip: !!collaborationTip,
        ...sessionContext,
      });

      setDiscussionAnalysis((prev) => {
        const base = prev || {};
        return {
          ...base,
          level: base.level ?? level,
          badgeTitle: base.badgeTitle ?? badgeTitle,
          badgeType: base.badgeType ?? badgeType,
          quote: topQuote?.quote || "",
          name: topQuote?.student || "",
          feedback: studentFacingFeedback,
          collaborationTip: collaborationTip,
        };
      });

      // Persist collaborationTip separately so it survives cleanup
      if (collaborationTip && setCollaborationTip) {
        setCollaborationTip(collaborationTip);
      }

      setIsAnalysisLoading(false);
      // Delay badge appearance
      setTimeout(() => {
        setShowDiscussionAnalyzed(true);
        hasAnalysisDataRef.current = true;
      }, 750);
    } catch (error) {
      console.error("Error parsing discussion analysis:", error, dataTrackEvent);
    }
  }
};
